import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useState } from 'react';
import axios from "axios";
import AdminUploadIndicator from '../CommonComponents/AdminUploadIndicator';
import AdminInfoBox from '../CommonComponents/AdminInfoBox';
import { getItem } from '../../Utils/localStorageUtils';
import { useDispatch } from 'react-redux';
import { languageCodeActionBackEnd, siteThemeActionBackEnd } from '../../redux/reduxAction';
import { toast } from 'react-toastify';
import AdminChunkUploadIndicator from '../CommonComponents/AdminChunkUploadIndicator';
import { getOptimizedChunkSize } from '../../Utils/chunkSizeUtils';

const MyContext = createContext();
export function MyProvider({ children }) {
    // Track subscription expiry state
    const [daysLeft, setDaysLeft] = useState(null);
    const [orgDetails, setOrgDetails] = useState(null);
    const [accessToken, setAccessToken] = useState(() => localStorage.getItem('access_token'));

    // cache and inflight trackers to avoid duplicate requests
    const orgFetchPromiseRef = useRef(null);
    const lastDepIdRef = useRef(null);


    const dispatch = useDispatch()
    const uploadSize = 2 * 1024 * 1024
    const sizeMBFormatter = (size) => {
        return size / 1024 / 1024

    }

    // Use shared chunk size utility for consistency
    const getChunkSize = getOptimizedChunkSize;

    const baseURL = process.env.REACT_APP_Baseurl
    const baseWebnexsURL = process.env.REACT_APP_Base_Webnexs_URL
    const DEPLOYMENT_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_ID
    const DEPLOYMENT_USER_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_USER_ID
    const DEPLOYMENT_TOKEN_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_TOKEN_ID

    if (!baseURL || !baseWebnexsURL || !DEPLOYMENT_ID || !DEPLOYMENT_USER_ID || !DEPLOYMENT_TOKEN_ID) {
        console.error("Missing one or more environment variables. Please check your .env file.");
    }

    const [infoBox, setInfoBox] = useState(false)
    const [loadingGifVideo, setLoadingGifVideo] = useState(null);
    const [siteMetadata, setSiteMetadata] = useState({});
    const [errorMessage, setErrorMessage] = useState("")

    const permissionApi = `${baseURL}/admin/user-permission`
    const themeApi = `${baseURL}/admin/Site-ThemeSetting/index`

    const token = localStorage.getItem('access_token')
    const [themeMode, setThemeMode] = useState(false)
    const [files, setFiles] = useState([]);
    const [uploadingFiles, setUploadingFiles] = useState([]);
    const [uploadingChunkFiles, setUploadingChunkFiles] = useState([]);
    const [cancellationControllers, setCancellationControllers] = useState([]);
    const [fileStatusMap, setFileStatusMap] = useState([]);
    const [fileResponse, setFileResponse] = useState([]);
    const abortControllers = useRef({});
    const fileStatusRef = useRef({});

    const formatBytes = (bytes) => {
        if (bytes === 0) return "0 B";
        const units = ["B", "KB", "MB", "GB", "TB"];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(2) + " " + units[i];
    };

    const fileIdGenerator = (file) => {
        return `${formatBytes(file?.size)}_${getItem("user_id")}_${file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9._-]/g, '')}`;
    };

    const clearCompletedFiles = () => {
        setUploadingFiles((prev) => {
            let data = [...prev]
            let filterwithoutcompletedFiles = data?.filter((item) => item.status !== "completed")
            return filterwithoutcompletedFiles
        })

    }
    const clearFile = (fileId) => {
        setUploadingFiles((prev) => {
            let data = [...prev]
            let filterwithoutcompletedFiles = data?.filter((item) => item.fileId !== fileId)
            return filterwithoutcompletedFiles
        })

    }

    const getVideoDuration = (file) => {
        return new Promise((resolve) => {
            const videoElement = document.createElement("video");
            videoElement.onloadedmetadata = () => {
                resolve(videoElement.duration);
            };
            videoElement.src = URL.createObjectURL(file);
        });
    };

    const updateFileStatus = (fileId, updates) => {
        setFileStatusMap(prev =>
            prev.map(item =>
                item.id === fileId ? { ...item, ...updates } : item
            )
        );
        fileStatusRef.current[fileId] = {
            ...(fileStatusRef.current[fileId] || {}),
            ...updates,
        };
    };

    const formatSpeed = (bytesPerSec) => {
        if (bytesPerSec > 1024 * 1024) return `${(bytesPerSec / (1024 * 1024)).toFixed(2)} MB/s`;
        if (bytesPerSec > 1024) return `${(bytesPerSec / 1024).toFixed(2)} KB/s`;
        return `${bytesPerSec.toFixed(2)} B/s`;
    };
    const handleOffline = () => {
        setUploadingFiles((prev) => {
            const updatedFiles = prev.map((file) =>
                file.status === "uploading"
                    ? { ...file, status: "pending", error: "Network error" }
                    : file
            );
            return updatedFiles;
        });
        // cancellationControllers.map((item) => {
        //     item.controller.abort();
        //     setUploadingFiles((prev) => {
        //         const updatedFiles = prev.map((file) =>
        //             file.fileId === item?.fileId ? { ...file, status: "failed", progress: 0, uploaded: 0 } : file
        //         );
        //         return updatedFiles;
        //     });
        //     setCancellationControllers((prev) => prev.filter(item => item.fileId !== item?.fileId))
        // })
    };
    const handleOnline = () => {
        setUploadingFiles((prev) => {
            const updatedFiles = prev.map((file) =>
                file.status === "pending"
                    ? { ...file, status: "uploading", error: "" }
                    : file
            );
            return updatedFiles;
        });
    };

    useEffect(async () => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('offline', handleOffline);
            window.addEventListener('online', handleOnline);
        };
    }, []);

    // Auto-fetch removed from here and moved to App.js/Dashboard.jsx coordination

    // Calculate daysLeft for trial period when orgDetails changes
    useEffect(() => {
        if (orgDetails?.trial_status === 1) {
            if (orgDetails?.start_date && orgDetails?.end_date) {
                const today = new Date();
                const end = new Date(orgDetails.end_date);
                const diffTime = end.getTime() - today.getTime();
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                setDaysLeft(diffDays > 0 ? diffDays : 0);
            } else {
                setDaysLeft(null);
            }
        } else {
            setDaysLeft(null);
        }
    }, [orgDetails]);


    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Check if there are any uploads in progress
            const inProgressUploads = fileStatusMap.some((file) => file.status === "uploading");
            if (inProgressUploads) {
                const message = "You have an ongoing upload. Are you sure you want to leave?";
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [fileStatusMap]);


    const themeSwitcher = () => {
        setThemeMode(!themeMode)
    };
    const infoBoxModelClose = () => {
        setInfoBox(false)
    }

    const fetchRequest = async ({ method, url, params = {}, data = {}, headers = {}, signal, timeout = 0 }) => {
        try {
            const authHeader = accessToken ? { Authorization: 'Bearer ' + accessToken } : {};

            const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
            const config = {
                method, url, params, data, signal,
                timeout: timeout, // 0 means unlimited timeout
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                headers: {
                    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                    ...authHeader,
                    ...headers,
                },
            };
            const response = await axios(config);
            return response?.data
        } catch (error) {
            const response = error?.response
            if (response?.status == 403) {
                setErrorMessage(response?.data?.message)
                setInfoBox(true)
            }
            throw error;
        }
    };

    const globalImageUplaodAPI = () => {
        const imageApi = `${baseURL}/admin/global-image-uploads`;
        return imageApi;
    }

    const imageValidationAPI = () => {
        const imageValidationApi = `${baseURL}/admin/compress_image`;
        return imageValidationApi;
    };

    const deleteImageFile = async (id, modelName) => {
        try {
            const response = await fetchRequest({
                method: 'DELETE',
                url: `${baseURL}/admin/global-image-delete`,
                data: { id, modelName },
            });
            if (response?.status) {
                // toast.success(response?.message);
            } else {
                toast.error(response?.message || "Failed to delete image");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to delete image");
        }
    };

    const hasEnvConfig = () => {
        return Boolean(
            DEPLOYMENT_ID?.toString().trim() &&
            DEPLOYMENT_USER_ID?.toString().trim() &&
            DEPLOYMENT_TOKEN_ID?.toString().trim()
        );
    };

    // check if trial or subscription has ended (regardless of grace period)
    const isSubscriptionEnded = () => {
        if (!hasEnvConfig() || !orgDetails) return false;

        // 1. Check if trial has ended
        if (orgDetails.trial_status === 1) {
            if (orgDetails.end_date) {
                const today = new Date();
                const end = new Date(orgDetails.end_date);
                if (end < today) return true;
            } else if (daysLeft === 0) {
                return true;
            }
        }

        // 2. Check if subscription has ended
        if (orgDetails.trial_status === 0) {
            // If they have a subscription expiration date, check it
            if (orgDetails.subscription_ends_at) {
                try {
                    const [day, month, year] = orgDetails.subscription_ends_at.split("-").map(Number);
                    if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                        const subscriptionEndDate = new Date(year, month - 1, day);
                        if (subscriptionEndDate < new Date()) return true;
                    }
                } catch (error) { }
            } else if (orgDetails.end_date) {
                // Fallback to end_date if subscription_ends_at is missing
                if (new Date(orgDetails.end_date) < new Date()) return true;
            }
        }

        return false;
    };

    // Centralized function to check if access should be BLOCKED (grace period over)
    // Centralized function to check if access should be BLOCKED
    const isExpired = () => {
        if (!hasEnvConfig() || !orgDetails) return false;
        return isSubscriptionEnded();
    };

    // Get appropriate message based on expiry type
    const getExpiryMessage = () => {
        const isTrial = orgDetails?.trial_status === 1;
        const gracePeriodDate = orgDetails?.grace_period_end || "grace period";

        if (isTrial) {
            return `Your Trail has ended. Your demo will also be deleted after the ${gracePeriodDate}. Please renew your subscription or contact support. Email: support@flicknexs.com`;
        } else {
            return `Your subscription has ended. Please renew to continue enjoying our services.`;
        }
    };

    const fetchSiteMetadata = async () => {
        try {
            const formData = {
                Login_user_type: 9,
                Login_user_id: null,
                Login_device_type: "web"
            };
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Header-index`, formData, {
                headers: {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json'
                }
            });
            if (response?.data) {
                setSiteMetadata(response.data.settings || {});
                if (response.data.loading_gif_video_url) {
                    localStorage.setItem('loadingGifVideo', response.data.loading_gif_video_url);
                    setLoadingGifVideo(response.data.loading_gif_video_url);
                }
                return response.data;
            }
        } catch (error) {
            console.error("Error fetching site metadata:", error);
        }
        return null;
    };


    const organisationDetails = async () => {
        if (!hasEnvConfig()) {
            console.warn("Skipping organisationDetails: Missing .env config");
            return null;
        }
        try {
            const envTokenId = (DEPLOYMENT_ID ?? '').toString().trim();
            const envUserId = (DEPLOYMENT_USER_ID ?? '').toString().trim();
            const envDepTokenId = (DEPLOYMENT_TOKEN_ID ?? '').toString().trim();

            const lsDeploymentId = (localStorage.getItem('deployment_id') ?? '').replace(/"/g, '').trim();
            const lsUserId = (localStorage.getItem('deployment_user_id') ?? '').replace(/"/g, '').trim();
            const lsDepTokenId = (localStorage.getItem('deployment_token_id') ?? '').replace(/"/g, '').trim();

            const payload = {
                token_id: envTokenId || lsDeploymentId || undefined,
                user_id: envUserId || lsUserId || undefined,
                deployment_token_id: envDepTokenId || lsDepTokenId || undefined,
            };

            const response = await fetchRequest({
                method: "POST",
                url: `${baseWebnexsURL}/userapi/current_plan`,
                data: payload,
                headers: {
                    Accept: 'application/json',
                    ...(payload?.deployment_token_id ? { token: payload.deployment_token_id, servicekey: payload.deployment_token_id } : {}),
                },
            });
            if (response?.status) {
                const depId = response?.plan_data?.[0]?.deployment_id || response?.data?.plan_data?.[0]?.deployment_id;
                const depUser = response?.plan_data?.[0]?.userid || response?.data?.plan_data?.[0]?.userid;
                const depToken = response?.org_data?.[0]?.token || response?.data?.org_data?.[0]?.token;
                if (depId) localStorage.setItem('deployment_id', depId);
                if (depUser) localStorage.setItem('deployment_user_id', depUser);
                if (depToken) localStorage.setItem('deployment_token_id', depToken);
                return response;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Organisation API Error:", error);
            return null;
        }
    };

    const saveOrganisationDetails = async (raw) => {
        if (!hasEnvConfig()) {
            console.warn("Skipping saveOrganisationDetails: Missing .env config");
            return null;
        }
        try {
            const payload = {
                org_data: raw?.org_data || raw?.data?.org_data || [],
                plan_data: raw?.plan_data || raw?.data?.plan_data || [],
                subscription_start_date: raw?.subscription_start_date || raw?.data?.subscription_start_date,
                subscription_end_date: raw?.subscription_end_date || raw?.data?.subscription_end_date,
            };

            // Ensure grace_period_end is in the first plan_data item if it exists in root
            if (payload.plan_data.length > 0) {
                const grace_period_end = raw?.grace_period_end || raw?.data?.grace_period_end;
                if (grace_period_end) {
                    payload.plan_data[0].grace_period_end = grace_period_end;
                }
            }
            if (!payload?.org_data?.length || !payload?.plan_data?.length) {
                console.error("saveOrganisationDetails: missing org_data or plan_data");
                return null;
            }
            const depId = payload?.plan_data?.[0]?.deployment_id;
            const depUser = payload?.plan_data?.[0]?.userid;
            const depToken = payload?.org_data?.[0]?.token;
            if (depId) localStorage.setItem('deployment_id', depId);
            if (depUser) localStorage.setItem('deployment_user_id', depUser);
            if (depToken) localStorage.setItem('deployment_token_id', depToken);
            const storeResponse = await fetchRequest({
                method: "POST",
                url: `${baseURL}/admin/organisation-store-update`,
                data: payload,
            });
            if (storeResponse?.status && storeResponse?.data) {
                setOrgDetails(storeResponse.data);
            }
            return storeResponse;
        } catch (error) {
            console.error("Save Organisation Error:", error);
            return null;
        }
    };


    // Auto-fetch removed from here because App.js handles the initial sync/fetch
    // and Dashboard.jsx also triggers it if needed. This prevents triple-fetching.

    const fetchOrganisationDetails = async (deployment_idArg, { force = false } = {}) => {
        if (!hasEnvConfig()) {
            console.warn("Skipping fetchOrganisationDetails: Missing .env config");
            return null;
        }
        const resolvedId = (deployment_idArg || DEPLOYMENT_ID || localStorage.getItem('deployment_id'))?.toString()?.trim();
        if (!resolvedId) {
            console.error("Fetch Organisation Error: Missing deployment_id");
            return null;
        }

        // If we already fetched for this deployment and not forcing, return cached data
        if (!force && orgDetails && lastDepIdRef.current === resolvedId) {
            return { status: true, data: orgDetails };
        }

        // If a request is already in-flight for the same ID, wait for it
        if (orgFetchPromiseRef.current && lastDepIdRef.current === resolvedId) {
            try {
                return await orgFetchPromiseRef.current;
            } catch (e) { /* fall through to retry */ }
        }

        lastDepIdRef.current = resolvedId;
        const p = (async () => {
            try {
                const storeResponse = await fetchRequest({
                    method: "GET",
                    url: `${baseURL}/admin/organisation-index`,
                    params: { deployment_id: resolvedId },
                });
                setOrgDetails(storeResponse?.data);
                return storeResponse;
            } catch (error) {
                console.error("Fetch Organisation Error:", error);
                return null;
            } finally {
                orgFetchPromiseRef.current = null;
            }
        })();
        orgFetchPromiseRef.current = p;
        return p;
    };

    const logout = () => {
        const redirectLocation = localStorage.getItem("location");

        localStorage.clear();
        setInfoBox(false);

        if (redirectLocation) {
            window.location.href = redirectLocation;
        } else {
            window.location.href = "/";
        }
    };

    useEffect(async () => {
        if (token) {
            await fetchRequest({
                method: 'GET',
                url: `${permissionApi}`,
                params: {},
                data: {},
            })
                .then(response => {
                    const alldata = response;
                    if (response?.status) {
                        dispatch({ type: "GET_USER_PERMISSION", payload: alldata })
                    }
                }).catch((error => {
                    dispatch({ type: "GET_USER_PERMISSION_FAILED", payload: '' })
                    console.error(error)
                }))
        }
    }, [token]);

    useEffect(async () => {
        if (token) {
            await fetchRequest({
                method: 'GET',
                url: `${themeApi}`,
                params: {},
                data: {},
            })
                .then(response => {
                    const gifFile = response?.Site_theme_setting[0]?.loading_gif_video;
                    if (response?.status) {
                        setLoadingGifVideo(gifFile);
                    }
                }).catch((error => {
                    console.error(error)
                }))
        }
    }, [token]);

    useEffect(async () => {
        if (token) {
            const response = await fetchRequest({
                method: 'GET',
                url: `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
                params: { source: "sidebar-management" },
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        dispatch({ type: "SIDEBAR_LABEL", payload: response?.label_management || [] })
                    }
                }).catch((error => {
                    dispatch({ type: "SIDEBAR_LABEL", payload: error?.response?.data?.message || [] })
                    toast.error(error?.response?.data?.message)
                }))

            await dispatch(siteThemeActionBackEnd())
            await dispatch(languageCodeActionBackEnd())

        }

    }, [token])

    // Version 1 without chunk 

    // const retryUpload = async (fileId) => {
    //     setUploadingFiles((prev) => {
    //         return prev.map((file) =>
    //             file.fileId === fileId
    //                 ? { ...file, status: "pending", progress: 0, uploaded: 0, error: "" } // Reset to 'pending' status
    //                 : file
    //         );
    //     });

    //     try {
    //         const fileToRetry = uploadingFiles.find(file => file.fileId === fileId);
    //         if (!fileToRetry) {
    //             console.error(`File with ID ${fileId} not found.`);
    //             return; // Ensure the file exists before trying to upload
    //         }

    //         // Retry the upload by calling the uploadFile method again
    //         await uploadFile(fileToRetry, fileId, fileToRetry?.api, fileToRetry?.from, fileToRetry, fileToRetry?.index);  // The uploadFile function should be called again for retry
    //     } catch (error) {
    //         console.error("Retry upload failed:", error);
    //     }
    // };


    // const cancelUpload = (fileId) => {
    //     const cancelController = cancellationControllers.find(controller => controller.fileId === fileId);
    //     if (cancelController) {
    //         cancelController.controller.abort();
    //         setUploadingFiles((prev) => {
    //             const updatedFiles = prev.map((file) =>
    //                 file.fileId === fileId ? { ...file, status: "canceled", progress: 0, uploaded: 0, error: "Canceled" } : file
    //             );
    //             return updatedFiles;
    //         });
    //         setCancellationControllers((prev) => prev.filter(item => item.fileId !== fileId))
    //     }
    // };


    // const handleFileChangeProvider = async (event, api, from, body) => {
    //     if (body?.storage?.videocipher_storage == 1 && body?.siteTheme?.enable_ppv_based_resolution == 1) {
    //         if (event.target.files.length > body?.storage?.videocipher_PPV_Resolution?.length) {
    //             toast.info(`Please only choose ${body?.storage?.videocipher_PPV_Resolution?.length} Videos`)
    //             return
    //         }
    //     }
    //     const selectedFiles = Array.from(event.target.files);

    //     const filesWithDuration = await Promise.all(
    //         selectedFiles?.map(async (file) => {
    //             const duration = await getVideoDuration(file);
    //             return { file, duration };
    //         })
    //     );

    //     setFiles((prevFiles) => [...prevFiles, ...filesWithDuration]);
    //     const existingFileNames = [];
    //     const newFilesToUpload = filesWithDuration?.filter((fileItem) => {
    //         const isExisting = uploadingFiles?.some(
    //             (uploadedFile) =>
    //                 uploadedFile?.file.name === fileItem?.file.name &&
    //                 (uploadedFile?.status === "completed" || uploadedFile?.status === "uploading")
    //         );

    //         if (isExisting) {
    //             existingFileNames.push(fileItem?.file.name); // Collect existing filenames
    //         }

    //         return !isExisting; // Only keep non-existing files
    //     });


    //     const newUploadingFiles = newFilesToUpload?.map((fileItem, index) => {
    //         const fileObj = {
    //             file: fileItem.file,
    //             progress: 0,
    //             status: "pending",
    //             duration: fileItem.duration,
    //             uploaded: 0,
    //             fileId: fileItem.file.name,
    //             id: "",
    //             error: ""
    //         };

    //         // Conditionally append fields
    //         if (body?.libraryId) fileObj.libraryId = body.libraryId;
    //         if (body?.source_type) fileObj.source_type = body.source_type;
    //         if (body?.upload_single) fileObj.upload_single = body.upload_single;
    //         if (body?.uploaded_type) fileObj.uploaded_type = body.uploaded_type;
    //         if (body?.upload_source_type) fileObj.upload_source_type = body.upload_source_type;
    //         fileObj.title = body?.title || fileItem?.file?.name;
    //         fileObj.resolution = body?.resolution || body?.resolutions?.[index]?.value;
    //         fileObj.resolutions = body?.resolutions?.[index]?.value;

    //         return fileObj;
    //     });

    //     setUploadingFiles((prev) => [...prev, ...newUploadingFiles]);
    //     if (newFilesToUpload?.length > 0) {
    //         await Promise.all(
    //             newFilesToUpload.map((fileItem, index) =>
    //                 uploadFile(fileItem, fileItem.file.name, api, from, body, index)
    //             )
    //         );

    //         // Optionally show skipped files as info
    //         if (existingFileNames.length > 0) {
    //             toast.info(`Skipped existing files: ${existingFileNames.join(", ")}`);
    //         }
    //     } else {
    //         toast.info(
    //             existingFileNames.length > 0
    //                 ? `All selected files already exist: ${existingFileNames.join(", ")}`
    //                 : "Skipping files that are already being uploaded or completed."
    //         );
    //     }

    // };


    // const uploadFile = async (fileItem, fileId, api, from, body, index) => {
    //     const formData = new FormData();
    //     const appendIfValid = (key, value) => value && formData.append(key, value);
    //     appendIfValid("file", fileItem?.file);
    //     appendIfValid("libraryId", body?.libraryId);
    //     appendIfValid("source_type", body?.source_type);
    //     appendIfValid("upload_single", body?.upload_single);
    //     appendIfValid("uploaded_type ", body?.uploaded_type);
    //     appendIfValid("upload_source_type", body?.upload_source_type);
    //     appendIfValid("title", body?.title || fileItem?.file?.name);
    //     appendIfValid("resolution", body?.resolution || body?.resolutions?.[index]?.value);
    //     appendIfValid("resolutions", body?.resolutions?.[index]?.value);

    //     const cancelController = new AbortController();
    //     setCancellationControllers((prev) => {
    //         if (prev.some(item => item.fileId === fileId)) {
    //             return prev;
    //         } else {
    //             return [...prev, { controller: cancelController, fileId }];
    //         }
    //     });
    //     setUploadingFiles((prev) => {
    //         const updatedFiles = prev.map((file) =>
    //             file.fileId === fileId ? { ...file, status: "uploading", uploaded: 0, progress: 0, speed: 0, error: "" } : file
    //         );
    //         return updatedFiles;
    //     });

    //     const startTime = Date.now();

    //     const onUploadProgress = (progressEvent) => {
    //         if (progressEvent.total && progressEvent.loaded) {
    //             const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //             const currentTime = Date.now();
    //             const elapsedTime = (currentTime - startTime) / 1000;
    //             const speed = elapsedTime > 0 ? Math.round(progressEvent.loaded / elapsedTime) : 0;

    //             setUploadingFiles((prev) => {
    //                 const updatedFiles = prev.map((file) =>
    //                     file.fileId === fileId ? { ...file, progress: percent, uploaded: progressEvent.loaded, speed, from: from, api: api } : file
    //                 );
    //                 return updatedFiles;
    //             });
    //         }
    //     };
    //     const uploadRequest = async () => {
    //         try {
    //             const response = await axios.post(api, formData, {
    //                 timeout: 0,
    //                 maxContentLength: Infinity,
    //                 maxBodyLength: Infinity,
    //                 headers: {
    //                     "Authorization": `Bearer ${token}`,
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //                 onUploadProgress,
    //                 signal: cancelController.signal,
    //             });

    //             if (response.status === 200) {
    //                 setUploadingFiles((prev) => {
    //                     const updatedFiles = prev.map((file) =>
    //                         file.fileId === fileId ? { ...file, status: "completed", from: from, id: response?.data?.id || response?.data?.video_id || response?.data?.Audio_id, error: "" } : file
    //                     );
    //                     return updatedFiles;
    //                 });
    //                 toast.success(response?.data?.message)
    //             } else {
    //                 setUploadingFiles((prev) => {
    //                     const updatedFiles = prev.map((file) =>
    //                         file.fileId === fileId ? { ...file, status: "failed", from: from, error: "" } : file
    //                     );
    //                     return updatedFiles;
    //                 });
    //                 throw new Error("Upload failed");
    //             }
    //         } catch (error) {
    //             if (axios.isCancel(error)) {
    //                 setUploadingFiles((prev) => {
    //                     const updatedFiles = prev.map((file) =>
    //                         file.fileId === fileId ? { ...file, status: "canceled", error: error?.response?.data?.message } : file
    //                     );
    //                     return updatedFiles;
    //                 });
    //                 console.log("Upload canceled:", error.message);
    //             } else {
    //                 console.error("Error during upload", error, typeof error);

    //                 setUploadingFiles((prev) => {
    //                     const updatedFiles = prev.map((file) =>
    //                         file.fileId === fileId ? { ...file, status: "failed", progress: 0, uploaded: 0, error: error?.response?.data?.message } : file
    //                     );
    //                     return updatedFiles;
    //                 });
    //             }

    //         }
    //     }
    //     uploadRequest();
    // };



    // Version 2 chunk file upload

    // Connection health check function
    const checkServerConnection = async () => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${baseURL}/admin/health-check`,
                timeout: 5000, // 5 second timeout for health check
            });
            return true;
        } catch (error) {
            console.warn('Server connection check failed:', error.message);
            return false;
        }
    };

    const handleFileChangeProvider = async (event, api, from, body, where, onUploadSuccess) => {
        const selectedFiles = Array.from(event?.target.files);
        if (
            body?.storage?.videocipher_storage === 1 &&
            body?.siteTheme?.enable_ppv_based_resolution === 1
        ) {
            const maxAllowed = body?.storage?.videocipher_PPV_Resolution?.length || 0;
            if (selectedFiles.length > maxAllowed) {
                toast.info(`Please only choose ${maxAllowed} Videos`);
                return;
            }
        }

        const newValidFiles = selectedFiles.filter(file => {
            const fileId = fileIdGenerator(file);
            const exists = fileStatusMap.some(f => f.id === fileId && ['uploading', 'completed', 'stopped'].includes(f.status));
            if (exists) {
                toast.info(`${file.name} already exists in the Library. You can restore it instead of uploading again `);
                return false;
            }
            return true;
        });

        const filesWithDuration = await Promise.all(newValidFiles.map(async file => ({
            file,
            duration: await getVideoDuration(file),
        })));

        // Create an array to store all upload promises
        const uploadPromises = [];
        filesWithDuration.forEach(({ file, duration }, index) => {
            const fileId = fileIdGenerator(file);
            const resolution = body?.resolutions?.[index]?.value || body?.resolution;
            setFileStatusMap(prev => [
                ...prev,
                {
                    id: fileId,
                    file,
                    status: 'idle',
                    progress: 0,
                    speed: '0 B/s',
                    error: '',
                    from: from,
                    duration,
                    resolution,
                    body,
                    api,
                    title: body?.title || file.name,
                }
            ]);

            // Begin upload and store the promise
            const uploadPromise = uploadFile(file, fileId, api, from, body, index, where, onUploadSuccess);
            uploadPromises.push(uploadPromise);
        });
        return Promise.all(uploadPromises);
    };

    const uploadFile = async (file, fileId, api, from, body, index, where, onUploadSuccess) => {
        const MAX_RETRY_ATTEMPTS = 3;
        const RETRY_DELAY_BASE = 1000; // 1 second base delay

        // Declare variables at function scope to avoid reference errors
        let uploaded = 0;
        let totalChunks = 0;

        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        const uploadChunkWithRetry = async (chunk, chunkIndex, formData, retryCount = 0) => {
            try {
                const response = await fetchRequest({
                    method: 'POST',
                    url: api,
                    data: formData,
                    timeout: 0, // Unlimited timeout for chunk upload
                });
                return response;
            } catch (error) {
                console.warn(`Chunk ${chunkIndex} upload failed (attempt ${retryCount + 1}):`, error.message);

                if (retryCount < MAX_RETRY_ATTEMPTS) {
                    const delay = RETRY_DELAY_BASE * Math.pow(2, retryCount); // Exponential backoff
                    console.log(`Retrying chunk ${chunkIndex} after ${delay}ms...`);
                    await sleep(delay);
                    return uploadChunkWithRetry(chunk, chunkIndex, formData, retryCount + 1);
                }
                throw error;
            }
        };

        try {
            const CHUNK_SIZE = getChunkSize(file?.size);
            totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            updateFileStatus(fileId, { status: 'uploading', error: '', speed: '0 B/s' });

            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            abortControllers.current[fileId] = source;

            const { resumeChunk: uploadedChunks = [] } = await fetchRequest({
                method: 'GET',
                url: `${baseURL}/admin/library/status?fileId=${fileId}`,
                data: {},
                timeout: 0,
            });

            uploaded = uploadedChunks?.length;

            for (let i = 0; i < totalChunks; i++) {
                if (uploadedChunks.includes(i)) continue;
                if (fileStatusRef.current[fileId]?.status === 'stopped') {
                    source.cancel('Upload stopped by user');
                    return;
                }

                const start = i * CHUNK_SIZE;
                const end = Math.min(file.size, start + CHUNK_SIZE);
                const chunk = file.slice(start, end);
                const formData = new FormData();
                formData.append('chunk', chunk);
                formData.append('fileId', fileId);
                formData.append('chunkIndex', i);
                formData.append('totalChunks', totalChunks);
                formData.append('fileName', file.name);
                formData.append('fileType', file?.type);
                ['libraryId', 'source_type', 'upload_single', 'uploaded_type', 'upload_source_type', 'title', 'resolution'].forEach(key => {
                    if (body?.[key]) formData.append(key, body?.[key]);
                });

                const startTime = Date.now();
                console.log(`Uploading chunk ${i + 1}/${totalChunks} (${((i / totalChunks) * 100).toFixed(1)}%)`);

                const response = await uploadChunkWithRetry(chunk, i, formData);

                const endTime = Date.now();
                const timeTaken = (endTime - startTime) / 1000;
                const speed = chunk.size / timeTaken;

                uploaded++;
                const progressPercent = Math.round((uploaded / totalChunks) * 100);
                updateFileStatus(fileId, {
                    progress: progressPercent,
                    speed: formatSpeed(speed),
                });
                if (uploaded === totalChunks) {
                    updateFileStatus(fileId, {
                        status: 'completed',
                        speed: '0 B/s',
                        responseId: response?.id || response?.video_id || response?.Audio_id
                    });
                    toast.success(`${file.name} uploaded successfully`);
                    if (where === "playout" && typeof onUploadSuccess === "function") {
                        await onUploadSuccess();
                    }
                    return response;
                }
            }
        } catch (err) {
            if (axios.isCancel(err)) {
                updateFileStatus(fileId, {
                    status: 'stopped',
                    error: 'Upload canceled',
                    speed: '0 B/s'
                });
                return;
            }

            let errorMessage = "Unknown error";
            if (err.code === "ECONNABORTED") {
                errorMessage = "Upload timed out - please check your connection";
            } else if (err.code === "ECONNREFUSED" || err?.message?.includes("ERR_CONNECTION_REFUSED")) {
                errorMessage = "Connection refused by server - please try again later";
            } else if (err.code === "ENOTFOUND" || err?.message?.includes("ERR_NAME_NOT_RESOLVED")) {
                errorMessage = "Server not found - check network connection";
            } else if (err?.response?.status === 504) {
                errorMessage = "Server timeout - upload will retry automatically";
            } else if (err?.response?.status >= 500) {
                errorMessage = "Server error - upload will retry automatically";
            } else if (err?.response?.status === 413) {
                setFileResponse(err?.response?.status)
                errorMessage = "Chunk too large - try reducing video quality";
            } else if (err?.response?.status === 429) {
                errorMessage = "Too many requests - upload will retry with delay";
            } else if (err?.message?.includes("NetworkError") || err?.message?.includes("Failed to fetch")) {
                errorMessage = "Network error - check your internet connection";
            } else if (err?.response?.data?.message) {
                errorMessage = err.response.data.message;
            } else if (err?.message) {
                errorMessage = err.message;
            }

            console.error(`Upload failed for file ${file.name}:`, {
                error: err,
                message: errorMessage,
                chunkProgress: `${uploaded}/${totalChunks} chunks uploaded`
            });

            updateFileStatus(fileId, {
                status: 'stopped',
                error: errorMessage,
                speed: '0 B/s'
            });
        }
    };

    const clearFileResponse = () => {
        setFileResponse(null);
    };

    const cancelUpload = (file) => {
        const fileId = fileIdGenerator(file);
        if (abortControllers.current[fileId]) {
            abortControllers.current[fileId].cancel('Upload stopped by user');
        }
        updateFileStatus(fileId, { status: 'stopped', speed: '0 B/s' });
    };

    const retryUpload = (fileMeta) => {
        let file = fileMeta?.file
        const fileId = fileIdGenerator(file);
        const fileMetaDetails = fileStatusMap.find(item => item.id === fileId);
        uploadFile(file, fileMeta?.id, fileMetaDetails?.api, fileMetaDetails?.from, fileMetaDetails?.body);
    };

    const removeFile = async (file) => {
        const fileId = fileIdGenerator(file);
        await fetchRequest({
            method: 'DELETE',
            url: `${baseURL}/admin/library/cancel?fileId=${fileId}`,
            data: {},
        });
        setFileStatusMap(prev => prev.filter(item => item.id !== fileId));
    };

    const [orientationCache, setOrientationCache] = useState(null);
    const parseOrientationSize = (val) => {
        if (!val) return null;
        const parts = String(val).toLowerCase().replace(/\s+/g, '').split('x');
        if (parts.length !== 2) return null;
        const w = parseInt(parts[0], 10);
        const h = parseInt(parts[1], 10);
        if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return null;
        return { width: w, height: h };
    };
    const getOrientationMap = async (force = false) => {
        try {
            if (orientationCache && !force) return orientationCache;
            const res = await fetchRequest({ method: 'GET', url: `${baseURL}/admin/orientation/index` });
            const list = res?.data || [];
            const map = {};
            list.forEach((item) => {
                const size = item?.width && item?.height ? { width: Number(item.width), height: Number(item.height) } : parseOrientationSize(item?.images_size);
                if (size && item?.slug) {
                    map[String(item.slug).toLowerCase()] = { ...size, name: item?.name, slug: item?.slug };
                }
            });
            setOrientationCache(map);
            return map;
        } catch (err) {
            return orientationCache || {};
        }
    };

    const gcd = (a, b) => {
        a = Math.abs(a || 0); b = Math.abs(b || 0);
        while (b) { const t = b; b = a % b; a = t; }
        return a || 1;
    };
    const simplifyRatio = (w, h) => {
        const g = gcd(w, h);
        const rw = Math.round(w / g);
        const rh = Math.round(h / g);
        return `${rw}:${rh}`;
    };
    const getImageDimensions = (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => resolve({ width: img.width, height: img.height });
            img.onerror = () => resolve({ width: 0, height: 0 });
        });
    };
    const validateImageRatio = async (file, expectedRatio, expectedWidth, expectedHeight) => {
        const img = await getImageDimensions(file);
        const ratio = img.width / (img.height || 1);
        const withinTol = Math.abs(ratio - expectedRatio) < 0.01;
        const dimensionMatch = img.width === expectedWidth && img.height === expectedHeight;
        return withinTol || dimensionMatch;
    };
    const validateOrientationBySlug = async (file, orientationSlug) => {
        if (!orientationSlug) return { ok: true };
        const slug = String(orientationSlug).toLowerCase();
        const actual = await getImageDimensions(file);
        const map = orientationCache || await getOrientationMap();
        const expected = map?.[slug];
        if (expected && expected.width && expected.height) {
            const expectedRatio = expected.width / expected.height;
            const actualRatio = actual.width / (actual.height || 1);
            const approxEqual = (a, b, tol = 0.02) => Math.abs(a - b) <= tol;
            const ok = approxEqual(actualRatio, expectedRatio) || (actual.width === expected.width && actual.height === expected.height);
            return { ok, actual, expected, slug, ratio: simplifyRatio(expected.width, expected.height) };
        }
        // basic orientation fallback
        let ok = true;
        if (slug === 'landscape') ok = actual.width > actual.height;
        else if (slug === 'portrait') ok = actual.height > actual.width;
        else if (slug === 'square') ok = actual.width === actual.height;
        return { ok, actual, slug };
    };
    const buildDynamicSubText = (fallbackText, slug) => {
        if (!slug) return fallbackText || '';
        const key = String(slug).toLowerCase();
        const cfg = (orientationCache || {})[key];
        if (cfg?.width && cfg?.height) {
            const ratio = simplifyRatio(cfg.width, cfg.height);
            const prefix = (fallbackText || '').split('(')[0]?.trim();
            const dynamicPart = `(${ratio} Ratio or ${cfg.width}px * ${cfg.height}px)`;
            return prefix ? `${prefix} ${dynamicPart}` : dynamicPart;
        }
        return fallbackText || '';
    };

    return <MyContext.Provider value={{ accessToken, setAccessToken, fetchRequest, deleteImageFile, organisationDetails, saveOrganisationDetails, fetchOrganisationDetails, loadingGifVideo, themeSwitcher, files, uploadingFiles, cancellationControllers, handleFileChangeProvider, retryUpload, cancelUpload, formatBytes, themeMode, clearCompletedFiles, clearFile, sizeMBFormatter, uploadSize, removeFile, fileStatusMap, getOrientationMap, orientationBySlug: orientationCache, simplifyRatio, validateImageRatio, validateOrientationBySlug, buildDynamicSubText, isExpired, isSubscriptionEnded, getExpiryMessage, hasEnvConfig, orgDetails, daysLeft, globalImageUplaodAPI, imageValidationAPI, fileResponse, clearFileResponse, siteMetadata, fetchSiteMetadata }}>

        {/* <AdminUploadIndicator uploadingFiles={uploadingFiles} /> */}
        <AdminChunkUploadIndicator uploadingFiles={fileStatusMap} />
        {infoBox && <AdminInfoBox modelClose={infoBoxModelClose} hideCloseBtn closeAction={infoBoxModelClose} confirmAction={logout} confirmText={"Login"} heading={errorMessage} message="Please login again Your Token Was expired" />}
        {children}
    </MyContext.Provider>
}
export function useMyContext() {
    return useContext(MyContext);
}